/**
 * "AI Helper" design tokens (Story 4.1, Task 2). The warm-gradient identity
 * from the designer's mockups (UX spec v1.1) — superseding the earlier
 * SkillRx-theme placeholder — surfaced as plain constants so the embed-safe,
 * scoped CSS (see `styles.ts`) themes without a runtime theming library.
 *
 * Hex values are the approximate mockup tokens (confirm against Figma). Where
 * white text sits on the warm gradient, `gradientStartOnText` is a darkened
 * orange so the text/background contrast meets WCAG AA (≥ 4.5:1) — per the
 * accessibility resolution in front-end-spec.md#Accessibility (tune the stop
 * rather than adding a scrim).
 */
export const tokens = {
  /** Warm gradient — orange → deep red (Ask button + panel header). */
  gradientStart: '#F5A623',
  gradientEnd: '#C0202B',
  /**
   * Darkened orange stop for the region where white text sits, so white-on-fill
   * meets AA contrast. `#B45309` (amber-700) gives ~5.9:1 against white.
   */
  gradientStartOnText: '#B45309',
  /** SkillsPass logo blue — "Powered by skillspass" lockup + citation superscripts. */
  skillsPassBlue: '#00AEEF',
  /** Dark text — headings + AI answer text. */
  darkText: '#1A2332',
  /** Neutral gray — secondary text, disclaimer, timestamps. */
  neutralGray: '#64748B',
  /** User message bubble background (light gray, right-aligned). */
  userBubbleBg: '#F1F3F5',
  /** Chat panel background. */
  panelBg: '#FFFFFF',
  /** Send / action affordance (dark circle, white arrow). */
  sendAction: '#1A2332',
  /** Assistant identity mark. */
  sparkle: '✦',
} as const;

export type ThemeTokens = typeof tokens;
